import { defineMessages } from 'react-intl';

export default defineMessages({
    searchForCompanyName: {
        id: '_.auto_company.search_for_company_name',
        defaultMessage: 'Please search for your company name'
    },
    manualCompanyToggle: {
        id: '_.auto_company.cant_find_company',
        defaultMessage: `Can't find the company?`
    },
    manualCompanyToggleLinkText: {
        id: '_.auto_company.enter_manually',
        defaultMessage: 'Enter it manually'
    },
    companyNotFoundErrorTitle: {
        id: '_.auto_company.company_not_found_error_title',
        defaultMessage: `Oops. We couldn't find your company`
    },
    companyNotFoundErrorContent: {
        id: '_.auto_company.company_not_found_error_content',
        defaultMessage: `Are you sure you have entered your registered company name? If you still can't find your company then`
    },
    companyNotFoundErrorLinkText: {
        id: '_.auto_company.company_not_found_error_link_text',
        defaultMessage: 'enter it manually'
    },
    searchForCompany: {
        id: '_.auto_company.search_for_company',
        defaultMessage: 'Search for your company'
    },
    noSearchTermContent: {
        id: '_.auto_company.no_search_term_content',
        defaultMessage:
            'Enter your full company name, as registered with Companies House'
    },
    warningTitle: {
        id: '_.auto_company.warning_title',
        defaultMessage: 'Oops. Something went wrong'
    },
    warningContent: {
        id: '_.auto_company.warning_content',
        defaultMessage: 'Please try to enter your company'
    },
    warningLinkText: {
        id: '_.auto_company.warning_link_text',
        defaultMessage: 'manually'
    },
    searchForMyCompany: {
        id: '_.auto_company.search_for_my_company',
        defaultMessage: 'Search for my company'
    },
    chooseCompanyHelperText: {
        id: '_.auto_company.choose_company_helper_text',
        defaultMessage: 'Choose your company (or'
    },
    chooseCompanyLinkText: {
        id: '_.auto_company.choose_company_link_text',
        defaultMessage: 'enter manually)'
    },
    registeredCompanyName: {
        id: '_.auto_company.registered_company_name',
        defaultMessage: 'Registered name'
    },
    searchPlaceholder: {
        id: '_.auto_company.search_placeholder',
        defaultMessage: 'Search...'
    },
    companyName: {
        id: '_.auto_company.company_name',
        defaultMessage: 'Company Name'
    },
    companyNumber: {
        id: '_.auto_company.company_number',
        defaultMessage: 'Company Number'
    },
    companyNumberType: {
        id: '_.auto_company.company_number_type',
        defaultMessage: 'Type'
    }
});
